import { c as _c } from "react/compiler-runtime";
interface SidebarItem {
  icon: React.ReactNode;
  text: string;
  component?: React.ReactNode;
  dataId?: string;
  action?: React.ReactNode;
}
type Props = {
  items: SidebarItem[];
  position: 'left' | 'right';
  stickyTopOffset: number;
  hasOppositeSidebar: boolean;
};
const SidebarSection = t0 => {
  const $ = _c(11);
  const {
    items,
    position,
    stickyTopOffset,
    hasOppositeSidebar
  } = t0;
  const positionClasses = position === "left" ? `laptop:col-span-3 laptop:block ${hasOppositeSidebar ? "lg:col-span-3" : "lg:col-span-2"}` : "lg:col-span-3 lg:block";
  const t1 = `rail-scroll sticky hidden overflow-y-auto overscroll-contain border-r border-ds-border-subtle pb-2 transition-all duration-300 ease-in-out ${positionClasses}`;
  const t2 = `${stickyTopOffset}px`;
  const t3 = `calc(100vh - ${stickyTopOffset}px)`;
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = {
      top: t2,
      maxHeight: t3
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== items) {
    t5 = items.map(_temp);
    $[3] = items;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <div className="flex flex-col">{t5}</div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1 || $[8] !== t4 || $[9] !== t6) {
    t7 = <div className={t1} style={t4}>{t6}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default SidebarSection;
function _temp(item) {
  return <div key={item.dataId ?? item.text} data-testid={item.dataId} className="mb-2 flex h-auto flex-col rounded-md"><div className="flex items-center gap-x-2 px-2 py-3">{item.icon && <div className="text-lg font-emphasis tracking-heading-3">{item.icon}</div>}{item.text && <div className="text-lg font-emphasis tracking-heading-3">{item.text}</div>}{item.action && <div className="ml-auto">{item.action}</div>}</div>{item.component && <div className="flex flex-col p-2">{item.component}</div>}</div>;
}